import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function getElementBy<T extends { id: string }>(
  idOrCallback: string | ((element: T) => boolean),
): (source: Observable<T[]>) => Observable<T | null> {
  return (source: Observable<T[]>): Observable<T | null> => {
    if (typeof idOrCallback !== 'function') {
      return source.pipe(
        map(
          (elements: T[]) =>
            elements.find((value) => value.id === idOrCallback) ?? null,
        ),
      );
    }

    return source.pipe(
      map((elements: T[]) => elements.find(idOrCallback) ?? null),
    );
  };
}
